<script setup>
import {USE_CATEGORY_TAG_KEY} from "./CategoryTagComposition";
import {inject, ref} from "vue";
import CategoryTagList from "./CategoryTagList.vue";
import draggable from 'vuedraggable';

const props = defineProps({
  _siteUrl: {
    type: String,
    required: true
  },
  category: {
    type: Object,
    required: true
  },
  campaigns: {
    type: Array,
    required: true
  },
  index: {
    type: Number,
    required: true
  }
});

const emits = defineEmits(['open-edit-category', 'open-delete-tag'])

//コンポジションの注入
const composition = inject(USE_CATEGORY_TAG_KEY);

//エラー文字列
const errors = ref([]);

//成功画面を表示する
const viewToast = () => {
  //成功表示用のトーストを得る
  const toast = document.querySelector('.js-successToast');

  //トーストがあれば表示
  if (toast) {
    toast.style.display = '';
    toast.classList.add('isDsply');
    setTimeout(() => { toast.classList.remove('isDsply') }, 1500);
  }
};

//キャンペーンを追加・削除する
const changeCampaign = async (payload) => {
  //サーバーに変更を依頼
  const result = payload.check
      ? await composition.setCampaign(payload.tagId)
      : await composition.deleteCampaign(payload.tagId);

  //成功表示
  if (result) {
    //トーストを出す
    viewToast();

    //成功したらチェックを全て外す
    campaignChecks.value = [];
  }

  //失敗したらエラーを表示
  else {
    errors.value = composition.state.errors;
  }
};

//カテゴリの編集モーダルを表示する
const showEditModal = () => {
  emits('open-edit-category', props.index);
};

//カテゴリのソート結果を DB に保持する
const sort = async () => {
  //エラーを空にする
  errors.value = [];

  //並び替えを依頼
  const result = await composition.setTagOrders(props.index);

  //成功表示
  if (result) {
    viewToast();
  }

  //失敗したらエラーを表示
  else {
    errors.value = composition.state.errors;
  }
};
</script>

<template>
  <div class="pageCtgryBox">
    <div class="pageCtgryTitleArea">
      <p class="pageCtgryIcon"><img
          :src="_siteUrl+'public_image/'+category.thumbnail"
          alt=""
      ></p>
      <p class="pageCtgryTitle">{{category.name === '' ? '(未設定)' : category.name}}<span style="color: #d00">{{errors.join(' ')}}</span></p>
      <button
          type="button"
          class="modBasicSecSwitchBtn mdEdit modModalSwitch"
          @click="showEditModal"
      >編集</button>
    </div>
    <div class="pageTagListArea">
      <draggable
          v-model="category.tags"
          item-key="id"
          tag="ul"
          class="pageTagList"
          @end="sort"
      >
        <template #item="{element, index}">
          <CategoryTagList
              :campaign-tag-ids="campaigns.map(campaign => Number(campaign.tag_id))"
              :category-name="category.name"
              :tag="element"
              :enable-delete="false"
              :_site-url="_siteUrl"
              :index="index"
              @change-check="changeCampaign"
              @delete-tag="emits('open-delete-tag')"
          />
        </template>
      </draggable>
    </div>
  </div>
</template>
